import { render, staticRenderFns } from "./MiniPaginator.vue?vue&type=template&id=4e1b0d73"
import script from "./MiniPaginator.vue?vue&type=script&lang=js"
export * from "./MiniPaginator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports